module.exports = __webpack_public_path__ + "img/revenue.b0f7ac48.svg";